import { useAuth0 } from "@auth0/auth0-react";
import { CompanyDataClientV1 } from "../auto-generated-clients/companydata-client-v1.generated";
import { CompanyDataClientV2 } from "../auto-generated-clients/companydata-client-v2.generated";
import { useAppConfig } from "rwo-react";

let companyDataClientV1: CompanyDataClientV1 | undefined;
let companyDataClientV2: CompanyDataClientV2 | undefined;

export const useCompanyDataServiceV1 = (): CompanyDataClientV1 => {
  const { getAccessTokenSilently } = useAuth0();
  const { config } = useAppConfig();

  if (!companyDataClientV1) {
    companyDataClientV1 = new CompanyDataClientV1(
      `${config.BackendAddress}${config.CompanyDataApiSuffix}`
    );
  }

  companyDataClientV1.setAccessToken(getAccessTokenSilently());

  return companyDataClientV1;
};

export const useCompanyDataServiceV2 = (): CompanyDataClientV2 => {
  const { getAccessTokenSilently } = useAuth0();
  const { config } = useAppConfig();

  if (!companyDataClientV2) {
    companyDataClientV2 = new CompanyDataClientV2(
      `${config.BackendAddress}${config.CompanyDataV2ApiSuffix}`
    );
  }

  companyDataClientV2.setAccessToken(getAccessTokenSilently());

  return companyDataClientV2;
};
